var _a, _b;
import * as tslib_1 from "tslib";
import { reduxKey } from './constants';
import { createPollRequest, createPollSuccess, updatePollRequest, updatePollSuccess, requestFailure, } from './actions';
var defaultState = {
    isSubmitting: false,
};
// createPollSuccess is fired by the saga just before redirecting to the
// poll's canonical page. While the browser is loading, the reducer for that
// action keeps the submit button disabled by artifically continuing the
// appearance that it's still submitting.
//
// If redirection UX changes, keep in mind the isSubmitting flag.
var actionHandlers = (_a = {},
    _a[createPollRequest.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { isSubmitting: true })); },
    _a[createPollSuccess.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { isSubmitting: true })); },
    _a[updatePollRequest.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { isSubmitting: true })); },
    _a[updatePollSuccess.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { isSubmitting: false })); },
    _a[requestFailure.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { isSubmitting: false })); },
    _a);
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        if (state === void 0) { state = defaultState; }
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    },
    _b);
export default reducers;
//# sourceMappingURL=reducer.js.map